<template>
  <div class="grid-view">
    <div
      v-show="showMainList && !showPriceCombinationStep"
      class="main-content"
      type="primary"
    >
      <fcl-search-bar
        :is-show-created-by="true"
        :is-show-sale-state="true"
        :is-query="true"
        :is-query-price="true"
        :show-currency="true"
        :show-price-no="true"
        :is-surcharge="true"
        :is-show-contract-no="true"
        :filter="filter"
        :config-id="'FclRealList'+configModule"
        @onLevelChanged="onLevelChanged"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemResetCallBack="toAdvancedQuery"
        @onGridRefresh="gridRefresh"
        @reset="rowData=[]"
      >
        <template slot="operations">
          <el-button no="quotation" type="primary" @click="onQuotation()">{{ $t('Pricing.Quotation') }}</el-button>
          <el-button no="subscribe" type="primary" @click="onSubscribe()">{{ $t('Pricing.Subscribe') }}</el-button>
          <el-button no="export" type="primary" @click="exportToExcel()">{{ $t('Pricing.Export') }}</el-button>
          <el-button no="combinationPlanQuery" type="primary" @click="showPriceCombinationStep = true">{{ $t('CargoMsg.Cargo_CombinationPlanQuery') }}</el-button>
          <span style="margin-left: 20px">{{ globalMsg }}</span>
        </template>
      </fcl-search-bar>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :config-module="configModule"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :export-file-name="priceUtil.getFileName('PriceFCL')"
        />
      </div>
      <div ref="txtRemark" style="height: 6%; width: 99%" @dblclick="onTxtRemarksDoubleClick()">
        <textarea v-model="txtRemarks" no="txtRemark" :disabled="true" style="width: 100%; margin-left: 10px; height: 100%;" :title="$t('Pricing.RemarkAreaToolTip')" />
      </div>
    </div>
    <subscribe-dialog v-if="subscribe.visible" :visible="subscribe.visible" :local-email="subscribe.localEmail" @close="onSubscribeClose" @saveLocalEmail="p=>{subscribe.localEmail=p}" />
    <price-dialog
      v-if="priceDialog.visible"
      :visible="priceDialog.visible"
      :price="priceDialog.price"
      :price-addon="priceDialog.priceAddon"
      :is-dangerous="priceDialog.isDangerous"
      :un-no="priceDialog.unNo"
      :etd-date="priceDialog.etdDate"
      :level="priceDialog.level"
      @close="onPriceDialogClose"
    />
    <quotation-detail-dialog
      v-if="quotationDetail.visible"
      :visible.sync="quotationDetail.visible"
      :model="quotationDetail.quotation"
      :editing="quotationDetail.isEditing"
      :show-quotation-detail="quotationDetail.showDetail"
    />
    <price-combination-step
      v-if="showPriceCombinationStep"
      :type="SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code"
      @back="showPriceCombinationStep = false"
    />
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import {
  queryOpenPriceFcls,
  queryByPriceNo
} from '@/api/price/priceFcl'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import SubscribeDialog from '../../PriceReal/components/PriceReal/SubscribeDialog'
import PriceDialog from '../../PriceReal/components/PriceReal/PriceDialog'
import DateUtils from '@/utils/dateUtils'
import FclSearchBar from '@/views/cargo/v0/Price/components/query/fclSearchBar'
import { TenantUtil } from '@/class/cargo/model/utils/TenantUtil'
import StrUtils from '@/utils/StrUtils'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { Quotation } from '@/class/model/price/Quotation'
import QuotationDetailDialog from '@/views/cargo/v0/Price/Quotation/components/quotationDetailDialog'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import { MultiCompanyUtil } from '@/class/cargo/model/utils/MultiCompanyUtil'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import PriceCombinationStep from '@/components/Cargo/Price/priceCombinationStep'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'FclRealList',
  components: {
    QuotationDetailDialog,
    FclSearchBar,
    PriceDialog,
    SubscribeDialog,
    PriceCombinationStep
  },
  props: {
    configModule: { type: String, default: '220100' }
  },
  data() {
    return {
      URL, SystemConstants,
      priceTypes: PriceConstant.PRICE_TYPES,
      priceUtil: PriceUtils,
      globalMsg: '', // 查询条数和勾选条数显示
      rowData: [],
      showLevel: true, // 是否显示运价等级
      txtRemarks: '',
      selectedRow: null,
      remarkChange: false,
      authedLevel: 99,
      targetLevel: 0,
      tenantUtil: null,
      subscribeEmail: '',
      filter: {
        total: 0,
        pol: '',
        pols: '',
        pods: '',
        pod: '',
        cod: '',
        col: '',
        rod: '',
        rol: '',
        carrier: [],
        region: '',
        polCityCode: '',
        podCityCode: '',
        cmbCreatedBy: 'createdBy',
        createdBy: 0,
        branch: 0,
        saleState: -1,
        txtBookingAgent: '',
        unNo: '',
        contractNo: '',
        level: '',
        currency: 'USD',
        beginDate: DateUtils.formatStandardDate(new Date()),
        endDate: '',
        dangerous: false,
        isAddon: false,
        direct: false,
        frequency1: false,
        frequency2: false,
        frequency3: false,
        frequency4: false,
        frequency5: false,
        frequency6: false,
        frequency7: false
      },
      proxy: {},
      quotationDetail: { // 详情
        quotation: null,
        visible: false,
        isEditing: false,
        showDetail: false
      },
      filterJson: {},
      showDetail: false,
      fullscreenLoading: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: this.onRowClickedEvent,
        onRowSelected: this.onRowChecked,
        getRowStyle: function(params) {
          if (params.data.priceState === 1) {
            return { background: '#c0c0c0' }
          }
        },
        onSelectionChanged: event => {
          const rows = event.api.getSelectedRows()
          this.globalMsg = rows.length > 0 ? StrUtils.substitute(this.$t('Pricing.selectedCount'), rows.length) : ''
        }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: ' ', maxWidth: 40, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('Pricing.PriceNo'), field: 'priceNo', colId: 'priceNo', width: 200,
          tooltipValueGetter: (params) => {
            return PriceUtils.priceNoTipFunc(params.data, this.tenantUtil)
          } },
        {
          headerName: this.$t('Pricing.POL'), field: 'pol', colId: 'pol', width: 200,
          cellRenderer: (params) => {
            const nameLabel = PriceUtils.getSeaportEnglishName(params.data, 'pol')
            if (!nameLabel) {
              return params.data.pol
            }
            return nameLabel
          },
          filterParams: {},
          filterValueGetter: (params) => {
            const nameLabel = PriceUtils.getSeaportEnglishName(params.data, 'pol')
            if (!nameLabel) {
              return params.data.pol
            }
            return nameLabel
          },
          tooltipValueGetter: (params) => {
            return this.polTipFunc(params.data)
          }
        }, { headerName: this.$t('Pricing.POD'), field: 'pod', colId: 'pod', width: 200,
          cellRenderer: (params) => {
            const nameLabel = PriceUtils.getSeaportEnglishName(params.data, 'pod')
            if (!nameLabel) {
              return params.data.pod
            }
            return nameLabel
          },
          filterParams: {},
          filterValueGetter: (params) => {
            const nameLabel = PriceUtils.getSeaportEnglishName(params.data, 'pod')
            if (!nameLabel) {
              return params.data.pod
            }
            return nameLabel
          },
          tooltipValueGetter: (params) => {
            return this.podTipFunc(params.data)
          } },
        { headerName: this.$t('Pricing.POLCity'), field: 'polCity', colId: 'polCity', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.seaportCityLabelFunc(params.data.pol)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.seaportCityLabelFunc(params.data.pol)
          }
        },
        { headerName: this.$t('Pricing.PODCity'), field: 'podCity', colId: 'podCity', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.seaportCityLabelFunc(params.data.pod)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.seaportCityLabelFunc(params.data.pod)
          }
        },
        { headerName: this.$t('Pricing.PODCountry'), field: 'cod', colId: 'cod', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.seaportCountryLabelFunc(params.data.pod)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.seaportCountryLabelFunc(params.data.pod)
          }
        },
        {
          headerName: this.$t('Pricing.Direct'), field: 'direct', colId: 'direct', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 200,
          cellRenderer: (params) => {
            const nameLabel = PriceUtils.getSeaportEnglishName(params.data, 'via')
            if (!nameLabel) {
              return params.data.via
            }
            return nameLabel
          },
          filterParams: {},
          filterValueGetter: (params) => {
            const nameLabel = PriceUtils.getSeaportEnglishName(params.data, 'via')
            if (!nameLabel) {
              return params.data.via
            }
            return nameLabel
          },
          tooltipValueGetter: (params) => {
            return this.viaTipFunc(params.data)
          }
        },
        { headerName: this.$t('Pricing.CabinState'), field: 'priceState', colId: 'priceState', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceStateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.PriceTrend'), field: 'trend', colId: 'trend', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.trendLabelFunc(params.value)
          } },
        {
          headerName: this.$t('Pricing.CabinNature'), field: 'share', colId: 'share', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.shareColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.EqType'), field: 'eqType', colId: 'eqType', width: 200
        },
        {
          headerName: '20\'', field: 'cost20', colId: 'cost20', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc(params, this.filter.level, this.filter.currency, this.authedLevel)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            params.value = params.data.cost20
            return PriceUtils.priceColumnLabelFunc(params, this.filter.level, this.filter.currency, this.authedLevel)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: '40\'', field: 'cost40', colId: 'cost40', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc(params, this.filter.level, this.filter.currency, this.authedLevel)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            params.value = params.data.cost40
            return PriceUtils.priceColumnLabelFunc(params, this.filter.level, this.filter.currency, this.authedLevel)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: '40\' HC', field: 'costhc', colId: 'costhc', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc(params, this.filter.level, this.filter.currency, this.authedLevel)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            params.value = params.data.costhc
            return PriceUtils.priceColumnLabelFunc(params, this.filter.level, this.filter.currency, this.authedLevel)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: '40\' NOR', field: 'cost40nor', colId: 'cost40nor', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc(params, this.filter.level, this.filter.currency, this.authedLevel)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            params.value = params.data.cost40nor
            return PriceUtils.priceColumnLabelFunc(params, this.filter.level, this.filter.currency, this.authedLevel)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: '45\'', field: 'cost45', colId: 'cost45', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc(params, this.filter.level, this.filter.currency, this.authedLevel)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            params.value = params.data.cost45
            return PriceUtils.priceColumnLabelFunc(params, this.filter.level, this.filter.currency, this.authedLevel)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.VAT'), field: 'sellVat', colId: 'sellVat', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.vatLabelFunc(params.data, params.value, this.targetLevel)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return PriceUtils.vatLabelFunc(params.data, params.data.sellVat, this.targetLevel)
          }
        },
        {
          headerName: this.$t('Pricing.PaymentTerm'), field: 'term', colId: 'term', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.dataGridColumnPaymentFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.carrierLabFunc(params.data, params.value)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return PriceUtils.carrierLabFunc(params.data, params.data.carrier)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.carrierTipFunc(params.data)
          }
        },
        {
          headerName: this.$t('Pricing.ContractNo'), field: 'contractNo', colId: 'contractNo', width: 200
        },
        { headerName: this.$t('Pricing.ShippingLine'), field: 'shippingLine', colId: 'shippingLine', width: 200 },
        { headerName: this.$t('Pricing.Lane'), field: 'lane', colId: 'lane', width: 200 },
        { headerName: this.$t('Pricing.Source'), field: 'bookingAgent', colId: 'bookingAgent', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.bookingAgentLabelFunc(params.data, params.value, this.tenantUtil)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return PriceUtils.bookingAgentLabelFunc(params.data, params.data.bookingAgent, this.tenantUtil)
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company,
              'cmpIdx', params.value, this.language)
          } },
        { headerName: this.$t('Pricing.DepartureDay'), field: 'frequency', colId: 'frequency8', width: 200,
          valueFormatter: (params) => {
            params.data.frequency = PriceUtils.frequencyLabelFunc(params.data, 'frequency')
            return params.data.frequency
          },
          filterParams: {},
          filterValueGetter: (params) => {
            params.data.frequency = PriceUtils.frequencyLabelFunc(params.data, 'frequency')
            return params.data.frequency
          }
        },
        { headerName: this.$t('Pricing.Days'), field: 'days', colId: 'days', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.daysColumnLabelFunc(params.data, params.value)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return PriceUtils.daysColumnLabelFunc(params.data, params.data.days)
          }
        },
        { headerName: this.$t('Pricing.ServiceMode'), field: 'serviceMode', colId: 'serviceMode', width: 200 },
        { headerName: this.$t('Pricing.ServiceCode'), field: 'serviceCode', colId: 'serviceCode', width: 200 },
        { headerName: this.$t('Pricing.Commodity'), field: 'commodity', colId: 'commodity', width: 200 },
        { headerName: this.$t('Pricing.Dock'), field: 'dock', colId: 'dock', width: 200 },
        { headerName: this.$t('Pricing.DestinationDock'), field: 'destinationDock', colId: 'destinationDock', width: 200 },
        { headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.remarkLabelFunc(params.data, params.value)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return PriceUtils.remarkLabelFunc(params.data, params.data.remarks)
          }
        },
        { headerName: this.$t('Pricing.PriceDateType'), field: 'priceDateType_a', colId: 'priceDateType_a', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.priceDateTypeColumnLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.FreeTime'), field: 'freeTime', colId: 'freeTime', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.dataGridColumnclnTimeFunc(params.value)
          } },
        { headerName: this.$t('Pricing.SaleState'), field: 'saleState', colId: 'saleState', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.saleStateLabelFunction(Number(params.value))
          } },
        { headerName: this.$t('Pricing.EffectiveDateType'), field: 'dateTypeEffective', colId: 'dateTypeEffective', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.priceFclDateTypeLabelFunction(params.value)
          } },
        { headerName: this.$t('Pricing.ExpirationDateType'), field: 'dateTypeExpiration', colId: 'dateTypeExpiration', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.priceFclDateTypeLabelFunction(params.value)
          } },
        { headerName: this.$t('Pricing.ReceivingInstructions'), field: 'receivingInstructions', colId: 'receivingInstructions', width: 200 },
        { headerName: this.$t('Pricing.amsEns'), field: 'amsEns', colId: 'amsEns', width: 200 },
        { headerName: this.$t('Pricing.overloadRemarks'), field: 'overLoadRemarks', colId: 'overLoadRemarks', width: 200 },
        { headerName: this.$t('Pricing.ShippingClause'), field: 'transportMode', colId: 'transportMode', width: 200 },
        { headerName: this.$t('Pricing.DepartureDay2'), field: 'frequency8', colId: 'frequency8_1', width: 200,
          valueFormatter: (params) => {
            return params.value ? params.value.replaceAll(',', '/') : ''
          },
          filterParams: {},
          filterValueGetter: (params) => {
            params.value = params.data.frequency8
            return params.value ? params.value.replaceAll(',', '/') : ''
          }
        },
        { headerName: this.$t('Pricing.customSpecs'), field: 'customSpecs', colId: 'customSpecs', width: 200 },
        { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.ClosingDay'), field: 'closingDay', colId: 'closingDay', width: 200,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.closingDayFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.ROD'), field: 'region', colId: 'region', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.regionForPriceFclLabelFunc(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.regionForPriceFclLabelFunc(params.data)
          }
        },
        { headerName: this.$t('Pricing.PriceType'), field: 'freightType', colId: 'freightType', width: 200,
          valueFormatter: (params) => {
            return CommonState.getNameByCode(this.priceTypes, params.value)
          }
        },
        { headerName: this.$t('SeaExport.Vessel'), field: 'vessel', colId: 'vessel', width: 200
        },
        { headerName: this.$t('SeaExport.Voyage'), field: 'voyageFlight', colId: 'voyageFlight', width: 200
        },
        { headerName: '20\' NOR', field: 'cost20nor', colId: 'cost20nor', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc(params, this.filter.level, this.filter.currency, this.authedLevel)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            params.value = params.data.cost40nor
            return PriceUtils.priceColumnLabelFunc(params, this.filter.level, this.filter.currency, this.authedLevel)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        { headerName: 'ETD', field: 'etd', colId: 'etd', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: 'ETA', field: 'eta', colId: 'eta', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }
      ],
      subscribe: {
        visible: false,
        localEmail: ''
      },
      priceDialog: {
        visible: false,
        isDangerous: false,
        level: 99,
        etdDate: '',
        price: null,
        priceAddon: null
      },

      showPriceCombinationStep: false
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    language() {
      return this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    }
  },
  watch: {
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.tenantUtil = await TenantUtil.getInstance()
      await MultiCompanyUtil.getInstance()
      this.authedLevel = this.getAuthedLevel()
    },
    fetchOrderRequirement() {
      // this.toQuery()
    },
    getAuthedLevel() {
      if (this.$checkPermission(['PFDA_*_0'])) {
        return 0
      } else if (this.$checkPermission(['PFDA_*_1'])) {
        return 1
      } else if (this.$checkPermission(['PFDA_*_2'])) {
        return 2
      }
      return 99
    },
    // 查询
    toSimpleQuery(proxy) {
      this.fullscreenLoading = getLoading()
      queryByPriceNo(proxy).then((res) => {
        this.rowData = res.data
        this.globalMsg = StrUtils.substitute(this.$t('Pricing.QueryRecords'), this.rowData.length)
        this.loadingEnd()
        if (this.rowData && this.rowData.length === 0) {
          this.$message.warning(this.$t('Pricing.NoRecord'))
        }
      }).catch(() => {
        this.loadingEnd()
      })
    },
    loadingEnd() {
      this.gridOptions.api.clearFocusedCell()
      this.txtRemarks = ''
      this.fullscreenLoading.close()
    },
    handleQueryData(res) {
      const _resMap = res.data
      this.loadingEnd()
      const isNoRecord = !(_resMap)
      if (isNoRecord || _resMap.hasOwnProperty('Count') && Number(_resMap['Count'][0]) === 0) {
        this.$message.warning(this.$t('Pricing.NoRecord'))
        this.rowData = []
        this.globalMsg = StrUtils.substitute(this.$t('Pricing.QueryRecords'), this.rowData.length)
        return
      }

      const count = Number(_resMap['Count'][0])
      // 只返回部分结果的话，弹窗提醒是否加载更多
      if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
        const msg = StrUtils.substitute(this.$t('Pricing.MaxQueryCount2'), 300)
        this.$confirm(msg, this.$t('Pricing.Tips'), {
          confirmButtonText: this.$t('Pricing.YesLabel'),
          cancelButtonText: this.$t('Pricing.NoLabel'),
          type: 'info',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        }).then(() => {
        }).catch(() => {
          this.proxy.isLimited = false
          this.toAdvancedQuery(this.proxy)
          return
        })
      }
      let tenantId = NaN
      let rs = []
      for (const item in _resMap) {
        if (item.indexOf('PF') === 0) {
          tenantId = Number(item.substr(2))
          const rs_tenant = this.getResultsByTenant(_resMap[item], tenantId)
          if (rs_tenant && rs_tenant.length > 0) {
            rs_tenant.forEach(tenant => {
              if (tenant && tenant.toString().indexOf('PriceFclAddonEx') > -1) {
                tenant.active = true
              }
            })
            PriceUtils.recordTenant(rs_tenant, tenantId)
            rs = rs.concat(rs_tenant)
          }
        }
      }
      if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
        rs.pop()
      }
      // 勾选了Addon,运价列表显示根据起运港过滤(查询条件分为多起运港，单起运港)。
      let result = []
      if (this.proxy.hasOwnProperty('isAddon') && (this.proxy['isAddon'] === true)) {
        if ((!this.proxy.hasOwnProperty('pol') || StrUtils.isEmpty(this.proxy.pol)) && (!this.proxy.hasOwnProperty('pols') || StrUtils.isEmpty(this.proxy.pols))) {
          result = result.concat(rs)
        } else {
          rs.forEach(price => {
            if (price.hasOwnProperty('pol_a')) {
              const pol = price['pol_a']
              if (this.proxy.hasOwnProperty('pol')) {
                const polStr = this.proxy['pol']
                if (polStr === pol) {
                  result.push(price)
                }
              }
              if (this.proxy.hasOwnProperty('pols')) {
                const pols = this.proxy['pols']
                if (pols.contains(pol)) {
                  result.push(price)
                }
              }
            }
            if (!price.hasOwnProperty('pol_a')) {
              const polFcl = price['pol']
              if (this.proxy.hasOwnProperty('pol')) {
                const polFclStr = this.proxy['pol']
                if (polFclStr === polFcl) {
                  result.push(price)
                }
              }
              if (this.proxy.hasOwnProperty('pols')) {
                const polsFcl = this.proxy['pols']
                if (polsFcl.contains(polFcl)) {
                  result.push(price)
                }
              }
            }
          })
        }
      } else {
        result = result.concat(rs)
      }
      this.rowData = result
      this.globalMsg = StrUtils.substitute(this.$t('Pricing.QueryRecords'), this.rowData.length)
    },
    getResultsByTenant(map) {
      let rs = []
      const type = 'R'
      if (map.hasOwnProperty(type)) {
        rs = map[type]
      }
      const types = ['ER', 'RE', 'ERE']
      types.forEach(type => {
        if (map.hasOwnProperty(type)) {
          rs = rs.concat(map[type])
        }
      })
      return rs
    },
    toAdvancedQuery(data) {
      this.proxy = data
      this.fullscreenLoading = getLoading()
      queryOpenPriceFcls(data).then((res) => { this.handleQueryData(res) }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    setBooleanValue(field) {
      if (this.filter[field]) {
        this.proxy[field] = this.filter[field]
      }
    },
    onQuotation() {
      const user = this.$store.getters.userInfo
      if (user.email === null || user.userPhone === null || user.fax === null) {
        this.$message.warning(this.$t('Pricing.PlsInputUserInfo'))
        return
      }
      console.info('getModel', this.gridOptions.api.getRowNode(4))
      const pf = this.selectedRow
      if (!pf) {
        this.$message.warning(this.$t('Pricing.noSelectedPrice'))
        return
      }
      if (!pf.active) {
        this.$message.warning(this.$t('Pricing.InactiveRate'))
        return
      }
      if (pf.priceState === 1) {
        this.$message.warning(this.$t('Pricing.SuspendRate'))
        return
      }
      if (pf.priceState === 2) {
        this.$message.warning(this.$t('Pricing.RejectRate'))
        return
      }
      const selectedItems = []
      const api = this.gridOptions.columnApi
      const qf = PriceUtils.createQuotationFclDetail(pf, this.targetLevel)
      qf.eq20 = ColumnUtils.getCellRenderValue(api, pf, 'cost20')
      if (qf.eq20.indexOf('(') > -1 && qf.eq20.indexOf(')') > -1) {
        qf.eq20 = '-' + qf.eq20.substring(1, qf.eq20.length - 1)
      }
      qf.eq40 = ColumnUtils.getCellRenderValue(api, pf, 'cost40')
      if (qf.eq40.indexOf('(') > -1 && qf.eq40.indexOf(')') > -1) {
        qf.eq40 = '-' + qf.eq40.substring(1, qf.eq40.length - 1)
      }
      qf.eqHc = ColumnUtils.getCellRenderValue(api, pf, 'costhc')
      if (qf.eqHc.indexOf('(') > -1 && qf.eqHc.indexOf(')') > -1) {
        qf.eqHc = '-' + qf.eqHc.substring(1, qf.eqHc.length - 1)
      }
      qf.eq45 = ColumnUtils.getCellRenderValue(api, pf, 'cost45')
      if (qf.eq45.indexOf('(') > -1 && qf.eq45.indexOf(')') > -1) {
        qf.eq45 = '-' + qf.eq45.substring(1, qf.eq45.length - 1)
      }
      selectedItems.push(qf)
      const quotation = new Quotation().fillDefaultValue().getData()
      quotation.beginDate = new Date()
      quotation.endDate = !pf ? new Date() : pf.endDate
      quotation.bookingAgent = pf === null ? 0 : pf.bookingAgent
      quotation.freightType = pf === null ? PriceConstant.PRICE_TYPE_ALL.code : pf.freightType
      quotation.type = PriceConstant.QUOTATION_FCL
      quotation.quotationFclDetail = selectedItems
      this.quotationDetail.quotation = quotation
      this.quotationDetail.showDetail = false
      this.quotationDetail.isEditing = true
      this.quotationDetail.visible = true
    },
    onSubscribe() {
      this.subscribe.visible = true
    },
    onSubscribeClose() {
      this.subscribe.visible = false
    },
    onPriceDialogClose() {
      this.priceDialog.visible = false
      this.priceDialog.data = {}
    },
    onLevelChanged(searchLevel) {
      if (searchLevel.showLevel !== this.showLevel) {
        this.showLevel = searchLevel.showLevel
      }
      const level = (searchLevel.showLevel) ? searchLevel.level : this.authedLevel
      if (this.targetLevel !== level) {
        this.targetLevel = level
      }
    },
    onRowDoubleClicked(e) {
      const data = e.data
      const { showLevel, filter, authedLevel, targetLevel, priceDialog, proxy } = this
      if (data) {
        if (showLevel && filter.level && filter.level === '0') {
          if (authedLevel > targetLevel) {
            this.$message.warn(this.$t('Price.YourPermissionIsNotEnough'))
            priceDialog.visible = false
            return
          }
        }
        priceDialog.isDangerous = !proxy.hasOwnProperty('priceNo') ? filter.dangerous : false
        priceDialog.unNo = !proxy.hasOwnProperty('priceNo') ? filter.txtUnNo : ''
        priceDialog.level = Number(this.targetLevel)
        priceDialog.price = data
        priceDialog.priceAddon = data.isAddon ? data : null
        priceDialog.etdDate = filter.beginDate || null
        priceDialog.visible = true
      }
    },
    onTxtRemarksDoubleClick() {
      this.$nextTick(() => {
        this.$refs.txtRemark.style.height = !this.remarkChange ? '30%' : '6%'
        this.remarkChange = !this.remarkChange
      })
    },
    onRowClickedEvent(e) {
      const data = e.data
      this.selectedRow = data
      this.txtRemarks = data.remarks + `\n${this.$t('Price.SailingSchedule2')} ` + data.frequency8 + '  ' + this.$t('Message.Voyage') + ' ' + data.days
      if (data.overLoadRemarks && data.overLoadRemarks.length > 0) {
        this.txtRemarks += this.$t('Price.OverweightDescription') + data.overLoadRemarks
      }
    },
    // 行首多选框勾选事件
    onRowChecked(event) {
      if (event.node.isSelected()) {
        this.onRowClickedEvent(event)
      }
    },
    polTipFunc(data) {
      if (data.hasOwnProperty('pol_a')) {
        return data.pol_a || data.pol
      }
      return data.pol
    },
    podTipFunc(data) {
      if (data.hasOwnProperty('pod_b')) {
        return data.pod_b || data.pod
      }
      return data.pod
    },
    viaTipFunc(data) {
      if (data.hasOwnProperty('pod_a') || data.hasOwnProperty('pol_b')) {
        return data.pod_a || data.pol_b || data.via
      }
      return data.via
    },
    gridRefresh() {
      this.gridOptions.api.refreshCells({ force: true })
    },
    exportToExcel() {
      const fileName = PriceUtils.getFileName('PriceFCL')
      const selectedRows = this.gridOptions.api.getSelectedRows()
      const rows = selectedRows.length === 0 ? this.rowData : selectedRows
      if (rows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecord'))
        return
      }
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      exportExcel(fileName, rows, [...allDisplayedColumns])
    }
  }
}
</script>
<style lang="scss" scoped>
</style>

